module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-down-1eca03ef4a23db15831de9ee21016747.svg";